import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import 'rxjs/add/observable/of';
import { CrawfordSnackbarService, CrawfordSpinnerService } from 'crawford-shell';


@Injectable()
export class ExceptionInterceptor implements HttpInterceptor {

  constructor(
    private snackbarService: CrawfordSnackbarService,
    private spinnerService: CrawfordSpinnerService
  ) {
   }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 200:
              window.location.href = error.url;
              break;
            case 400:
              this.snackbarService.displayErrorMessage(error.error.message, 10000);
              this.spinnerService.stopPageSpinner();
              break;
            case 401:
              this.snackbarService.displayErrorMessage('User not Authorised');
              this.spinnerService.stopPageSpinner();
              break;
            default:
              this.snackbarService.displayErrorMessage('There was an error with the server, please contact your administrator');
              this.spinnerService.stopPageSpinner();
              break;
          }
        }
        return Observable.of(error);
      })
    );
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/http-interceptors/exception-interceptor.ts